import { VisibilityElement } from './visibility'
import { ModalElement } from './modal'
import { InViewElement } from './in-view'
import { ReadMore } from './read-more'
import { PhysicsBalls } from './physics-balls/physics-balls'
import { StickyHeader } from './sticky-header'
import { MiniCart } from './mini-cart'
import { KlaviyoForm } from './klaviyo-form'
import { ProductForm } from './product-form'
import { VariantSelector } from './variant-selector'
import { EnhancedProductForm } from './enhanced-product-form'
import { QuantityInput } from './quantity-input'
import { Carousel } from './carousel'

import 'snippets/notice-global/notice-global'
import { CustomForm } from '@/components/custom-elements/custom-form'
import { LightBoxElement } from '@/components/custom-elements/lightbox'
import 'snippets/navigation/localization-form'
import register from 'preact-custom-element'
import { NavAnchor } from './nav-anchor'
import { ListDisplayElement } from '@/components/custom-elements/list-display'
import { TabbedContent } from './tabbed-content'
import { CountdownElement } from './countdown'

register(MiniCart, 'mini-cart', ['acceleratedCheckout'])
customElements.define('x-visibility', VisibilityElement)
customElements.define('x-lightbox', LightBoxElement)
customElements.define('x-modal', ModalElement)
customElements.define('x-in-view', InViewElement)
customElements.define('x-tabbed-content', TabbedContent)
customElements.define('x-quantity-input', QuantityInput)
customElements.define('sticky-header', StickyHeader)
customElements.define('read-more', ReadMore)
customElements.define('physics-balls', PhysicsBalls)
customElements.define('klaviyo-form', KlaviyoForm)
customElements.define('nav-anchor', NavAnchor)
customElements.define('product-form', ProductForm)
customElements.define('variant-selector', VariantSelector)
customElements.define('x-list-display', ListDisplayElement)
customElements.define('x-custom-form', CustomForm)
customElements.define('enhanced-product-form', EnhancedProductForm)
customElements.define('x-carousel', Carousel)
customElements.define('x-countdown', CountdownElement)
